<template>
  <div class="answer-item">
    <div class="label" v-if="item.label">{{ item.label }}</div>
    <div class="desc" v-if="item.children">
      <div class="desc" v-for="(cItem, index2) in item.children" :key="index2">
        {{ cItem.text }}
      </div>
    </div>
    <div class="desc" v-else-if="item.desc">{{ item.desc }}</div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.answer-item {
  display: flex;
  flex-direction: column;
  gap: 16px 0;
  .label {
    font-size: 18px;
    font-weight: 500;
    color: var(--color-1);
  }
  .desc {
    font-size: 18px;
    color: var(--color-3);
  }
}

@media screen and (max-width: 767px) {
  .answer-item {
    gap: 8px 0;
    .label {
      font-size: 13px;
    }

    .desc {
      font-size: 12px;
    }
  }
}
</style>
